import React from "react";
import Button from "theme/components/atoms/Button/Button";
import IconWithNotification from "theme/components/molecules/IconWithNotification";
import CartNavigation from "theme/layouts/Header/Navigation/CartNavigation";
import SubNavigation from "theme/layouts/Header/Navigation/SubNavigation";
import { useIntl, defineMessages } from "react-intl";
import Tooltip from "theme/components/atoms/Tooltip/Tooltip";
const messages = defineMessages({
  cart: {
    id: "layouts.Header.Navigation.cart",
    defaultMessage: "My Cart",
  },
  cartLength: {
    id: "layouts.Header.Navigation.cartLength",
    defaultMessage: "{quantity, plural, =1 {1 product} other {# products}}",
  },
  pleaseLogin: {
    id: "components.atoms.Typography.pleaseLogin",
    defaultMessage: "Please login",
  },
});

const MiniCartIcon = ({
  canDisplayLinkOnListing,
  cartLength,
  selectMenu,
  renderSubNav,
}) => {
  const intl = useIntl();
  const tooltipId = "mini-cart-tooltip";

  const commonIconProps = {
    icon: "shopping_cart",
    type: "svg",
    notification: cartLength,
    notificationMessage: intl.formatMessage(messages.cartLength, {
      quantity: cartLength,
    }),
  };

  const commonButtonProps = {
    appearance: "icon-header",
    id: "mini-cart-icon",
    "aria-label": intl.formatMessage(messages.cart),
  };

  if (!canDisplayLinkOnListing) {
    return (
      <li className="navigation__item">
        <Button {...commonButtonProps} aria-describedby={tooltipId} disabled>
          <IconWithNotification {...commonIconProps} />
        </Button>
        <Tooltip target="mini-cart-icon" direction="bottom" id={tooltipId}>
          {intl.formatMessage(messages.pleaseLogin)}
        </Tooltip>
      </li>
    );
  }

  return (
    <li className="navigation__item">
      <Button {...commonButtonProps} onClick={() => selectMenu("cart")}>
        <IconWithNotification {...commonIconProps} />
      </Button>
      {renderSubNav("cart")(
        <SubNavigation appearance="aside" onClose={() => selectMenu(null)}>
          <CartNavigation toggleMiniCart={selectMenu} />
        </SubNavigation>
      )}
    </li>
  );
};

export default MiniCartIcon;
